// extracted by css-extract-rspack-plugin
export default {"root":"root-PMzmhb","header":"header-MlzQRS","headerSeparator":"headerSeparator-rF7vbo","title":"title-Pl49Ab text-5xl-semibold"};